import React, { useEffect, useState } from 'react';
import { Image } from 'antd';
import { createGlobalStyle } from 'styled-components';

const AntImagePreviewStyles = createGlobalStyle`
  .ant-image-preview-root.code360-ant-image-preview .ant-image-preview-mask,
  .code360-ant-image-preview.ant-image-preview-root .ant-image-preview-mask {
    background: rgba(0, 0, 0, 0.86) !important;
    backdrop-filter: blur(22px) saturate(160%) contrast(110%);
    -webkit-backdrop-filter: blur(22px) saturate(160%) contrast(110%);
  }
  .ant-image-preview-root.code360-ant-image-preview .ant-image-preview-wrap,
  .code360-ant-image-preview.ant-image-preview-root .ant-image-preview-wrap {
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
  }
  .ant-image-preview-root.code360-ant-image-preview .ant-image-preview-img,
  .code360-ant-image-preview.ant-image-preview-root .ant-image-preview-img {
    border-radius: 14px;
    box-shadow:
      0 24px 70px rgba(0, 0, 0, 0.55),
      0 8px 26px rgba(0, 0, 0, 0.35);
  }
`;

/** Keeps trigger Images in the layout tree (rc-image / PreviewGroup need real nodes). */
const hiddenImageTriggerStyle = {
    position: 'fixed',
    left: 0,
    top: 0,
    width: 64,
    height: 64,
    margin: 0,
    padding: 0,
    overflow: 'hidden',
    opacity: 0,
    pointerEvents: 'none',
    zIndex: -1,
};

/**
 * Ant Design image preview with glassy blurred backdrop.
 * - Single: pass `src`
 * - Gallery: pass `sources` (2+) and optional `startIndex`; use `onSlideChange` to sync parent index
 */
export default function AntImagePreview({
    open,
    onClose,
    zIndex = 2000,
    src,
    sources,
    startIndex = 0,
    onSlideChange,
}) {
    const list =
        Array.isArray(sources) && sources.length > 0
            ? sources.filter(Boolean)
            : src
              ? [src]
              : [];

    const [current, setCurrent] = useState(() =>
        list.length > 0 ? Math.min(Math.max(0, startIndex), list.length - 1) : 0,
    );

    useEffect(() => {
        if (!open || list.length === 0) return;
        const next = Math.min(Math.max(0, startIndex), list.length - 1);
        setCurrent(next);
    }, [open, startIndex, list.length]);

    if (!open || list.length === 0) return null;

    const previewBase = {
        visible: true,
        zIndex,
        rootClassName: 'code360-ant-image-preview',
        onVisibleChange: (visible) => {
            if (!visible) onClose?.();
        },
    };

    return (
        <>
            <AntImagePreviewStyles />
            {list.length > 1 ? (
                <Image.PreviewGroup
                    preview={{
                        ...previewBase,
                        current,
                        onChange: (i) => {
                            setCurrent(i);
                            onSlideChange?.(i);
                        },
                    }}
                >
                    {list.map((url, i) => (
                        <Image key={`${url}-${i}`} src={url} alt="" style={hiddenImageTriggerStyle} />
                    ))}
                </Image.PreviewGroup>
            ) : (
                <Image src={list[0]} alt="" style={hiddenImageTriggerStyle} preview={previewBase} />
            )}
        </>
    );
}
